import { ENVIRONMENT } from '@experiences/constants';
import type { EnvVariableType } from '@experiences/interfaces';

export function getEnvironment() {
    if (window.location.origin.toLowerCase().indexOf('localhost') >= 0) {
        return ENVIRONMENT.LOCAL;
    }
    return window.env?.ENVIRONMENT;
}

// Return variable value found in envJS
export function getEnvVariableValue(envKey: string | EnvVariableType): any {
    if (typeof window === 'undefined') {
        return undefined;
    }

    return window.env?.[envKey];
}
